(function () {
  var CODE_ATTR = '_raf_code';
  var NAME_ATTR = '_raf_advocate_name';
  var CODE_STORAGE = 'raf_code';
  var NAME_STORAGE = 'raf_advocate_name';
  var SET_AT_STORAGE = 'raf_code_set_at';
  /* Stored under NAME_STORAGE while a lookup is in flight. Cannot be a name. */
  var NAME_PENDING = '\u0001';
  var CODE_PATTERN = /^[A-Z]{4}\d{4}$/;
  /* Matches the 14-day Shopify-refunds wait window in the RAF architecture —
     anything older has either been credited or lapsed. */
  var TTL_MS = 14 * 24 * 60 * 60 * 1000;

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function safeRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }
  function clearReferralStorage() {
    safeRemove(CODE_STORAGE);
    safeRemove(NAME_STORAGE);
    safeRemove(SET_AT_STORAGE);
  }

  function okOrThrow(r) {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r;
  }

  /* Logging is the end of the line here: every theme page load re-syncs the
     attributes, so a rejected write is retried on the next navigation and
     nothing on this page can act on it sooner. It still has to be visible —
     a 429 from /cart/update.js used to vanish, and with it the referral code.
     Always resolves — to whether the write landed — so a caller can sequence
     a follow-up write on it. */
  function writeCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(okOrThrow)
      .then(function () { return true; })
      .catch(function (error) {
        console.error('referral-tracking: cart attribute write failed', error);
        return false;
      });
  }

  /* Shopify drops an attribute set to the empty string. Guarded on the code
     Liquid rendered into the page so an ineligible shopper does not POST on
     every page load — only on the one where a stale attribute is still there. */
  function clearCartReferral() {
    if (!window.__rafCartCode) return;
    var cleared = {};
    cleared[CODE_ATTR] = '';
    cleared[NAME_ATTR] = '';
    writeCartAttributes(cleared);
  }

  /* Order-status page short-circuit. Dormant on theme pages — only fires
     when this script is wired into Shopify's checkout Additional Scripts. */
  if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.OrderStatus) {
    clearReferralStorage();
    return;
  }

  /* TTL sweep on every theme page load. Backfills a timestamp for users who
     stored a code before this code shipped, so the TTL eventually applies. */
  var existingCode = safeGet(CODE_STORAGE);
  var setAt = parseInt(safeGet(SET_AT_STORAGE), 10);
  if (existingCode && !setAt) {
    safeSet(SET_AT_STORAGE, Date.now().toString());
  } else if (setAt && (Date.now() - setAt) > TTL_MS) {
    clearReferralStorage();
  }

  function renderAdvocateName(name) {
    if (!name || typeof document === 'undefined') return;
    var slots = document.querySelectorAll('.raf-advocate-name');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = name;
    }
  }

  function renderCode(code) {
    if (!code || typeof document === 'undefined') return;
    var slots = document.querySelectorAll('.raf-code');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = code;
    }
  }

  var prevCode = safeGet(CODE_STORAGE);
  var params = new URLSearchParams(window.location.search);
  var urlCode = params.get('ref');

  if (urlCode) {
    var normalized = urlCode.toUpperCase().trim();
    if (CODE_PATTERN.test(normalized)) {
      safeSet(CODE_STORAGE, normalized);
      safeSet(SET_AT_STORAGE, Date.now().toString());
      /* A different code is a different advocate: forget the old name so the
         lookup past the gates runs again for this one. */
      if (normalized !== prevCode) safeRemove(NAME_STORAGE);
    }
  }

  var storedCode = safeGet(CODE_STORAGE);
  if (storedCode && !CODE_PATTERN.test(storedCode)) storedCode = null;

  /* The cart attribute rides Shopify's server-set cart cookie, which outlives
     script-writable storage: the TTL sweep above drops storage without touching
     the cart, and WebKit evicts storage long before that cookie lapses. Both
     checks below exist to clear the cart, so they read the code Liquid rendered
     for it whenever storage no longer carries one — otherwise a cart the
     browser has forgotten about rides into checkout uncleared. */
  var carriedCode = storedCode || window.__rafCartCode;

  /* An advocate must never carry their own code. The discount function refuses
     it — they are not a first-time buyer — and orders/create then books the
     order as skipped_self, so the attribute buys nothing and the checkout reads
     as broken to the one person most likely to complain about it. */
  if (window.__rafOwnCode && carriedCode === window.__rafOwnCode) {
    clearReferralStorage();
    clearCartReferral();
    return;
  }

  /* The welcome offer comes off a first order. Carrying the code into a
     returning customer's cart earns them no discount but still credits the
     advocate on orders/create — a reward paid for a referral that never
     happened. Storage is left alone: a genuinely new shopper may still use
     this browser logged out, and the code is theirs to redeem. */
  if (window.__rafOrdersCount > 0) {
    clearCartReferral();
    return;
  }

  if (!storedCode) return;

  /* Rendered only past the eligibility checks above. Running it earlier put a
     live-looking code under the welcome page's "Show this code to the staff"
     copy for a shopper the note directly above had just told the code would not
     apply to — the two surfaces contradicted each other. */
  renderCode(storedCode);

  var storedName = safeGet(NAME_STORAGE);
  /* A pending mark seen at load time was left by a lookup that never
     settled — the shopper navigated away, or another tab is mid-flight —
     so it counts as not looked up, never as a name. */
  if (storedName === NAME_PENDING) storedName = null;
  if (storedName) renderAdvocateName(storedName);

  /* The name key is always sent: /cart/update.js merges per key, so leaving it
     out after a code switch keeps advocate A's name on the cart next to
     advocate B's code. An empty string deletes it (the idiom
     clearCartReferral relies on). */
  var attrs = {};
  attrs[CODE_ATTR] = storedCode;
  attrs[NAME_ATTR] = storedName || '';
  var codeWrite = writeCartAttributes(attrs);

  /* The advocate-name lookup belongs here, past the gates, keyed on the stored
     code rather than on the URL: a shopper the gates just turned away must not
     get a personalised "Anna sent you…" line, and their browser must not spend
     a request on it. Storage tracks the lookup, not the arrival — null means
     not looked up yet for this code, '' means looked up and nothing to show —
     so a browser whose first visit was gated still gets the name on the next
     eligible load. */
  if (storedName !== null) return;

  /* Mark the attempt before making it, and bail if the mark did not stick: a
     browser that reads storage but cannot write it (quota, legacy private
     mode) would otherwise hit the app proxy on every page view for the
     fortnight the code lives here. */
  safeSet(NAME_STORAGE, NAME_PENDING);
  if (safeGet(NAME_STORAGE) !== NAME_PENDING) return;

  fetch('/apps/raf/advocate-name?code=' + encodeURIComponent(storedCode), {
    headers: { 'Accept': 'application/json' },
  })
    .then(function (r) {
      /* The Worker answers an unknown code with its own JSON 404; Shopify
         answers an unconfigured proxy (app removed, prefix changed) with an
         empty 404 under the same content type. Only the first is a data
         outcome that ends the lookup — the second must read as an outage. */
      if (r.status === 404) {
        return r.json()
          .catch(function () { return null; })
          .then(function (body) {
            if (body && body.error === 'code_not_found') return null;
            throw new Error('HTTP 404 from the proxy, not the Worker');
          });
      }
      return okOrThrow(r).json();
    })
    .then(function (body) {
      /* Bind the response to the code it was fetched for: another tab can
         store a different code while this one is in flight, and its name
         must not land on that code — in storage, the DOM or the cart. */
      if (safeGet(CODE_STORAGE) !== storedCode) return;
      var name = body && typeof body.first_name === 'string' ? body.first_name : '';
      safeSet(NAME_STORAGE, name);
      if (!name) return;
      renderAdvocateName(name);
      var named = {};
      named[NAME_ATTR] = name;
      /* Sequenced behind the code write, which carried the blank name: two
         unordered POSTs let a slow cart mutation land the blank last. And only
         if that write landed — otherwise the cart still holds whatever code
         it had, and this name must not sit beside it. The next load re-sends
         both keys together. */
      codeWrite.then(function (landed) {
        if (landed) writeCartAttributes(named);
      });
    })
    .catch(function (error) {
      /* Anything else — network, 5xx, an app-proxy error page in place of
         JSON — is transient: withdraw the mark so the next load tries again.
         The first load after a link click is when the Worker is coldest. */
      /* Withdraw only a mark that is still ours: another tab looking up the
         same code may already have stored the name this one failed to get. */
      if (safeGet(CODE_STORAGE) === storedCode && safeGet(NAME_STORAGE) === NAME_PENDING) {
        safeRemove(NAME_STORAGE);
      }
      console.error('referral-tracking: advocate-name lookup failed', error);
    });
})();
